<div *ngFor="let item of items">

    <div *ngIf="item.url" class="embed-responsive embed-responsive-4by3" [ngClass]="item.customClass">
        
        <iframe 
            [src]="getSafeResourceURL(item.url)"
            class="embed-responsive-item w-100 h-100"
            allowfullscreen>
        </iframe>

    </div>

</div>